import React, { useEffect, useRef, useReducer } from 'react'
import Hero from '../components/gift-card/Hero'
import Location from '../components/gift-card/Location'
import ChooseGift from '../components/gift-card/ChooseGift'
import ChoosePackage from '../components/gift-card/ChoosePackage'
import RecipientInfo from '../components/gift-card/RecipientInfo'
import ChooseAmount from '../components/gift-card/ChooseAmount'
import GiftCardContext, {
  giftCardReducer,
  giftCardState
} from '../components/gift-card/GiftCardContext'
import { GiftCardWrapper } from '../components/gift-card/styles'
import {
  fetchMarketPackages,
  fetchGiftCard
} from '../services/GraphQlClientService'
import { groupBy } from 'lodash'
import Head from 'next/head'
import { resetGiftCardState } from '../helpers/resetGiftCardState'
import { useRouter } from 'next/router'
import { useMarketContext } from '../components/MarketContext'

const GiftCards = () => {
  const { markets, selectedMarket, setSelectedMarket } = useMarketContext()
  const section4 = useRef(null)
  const router = useRouter()
  const [state, dispatch] = useReducer(giftCardReducer, giftCardState)

  useEffect(() => {
    const { query } = router
    if (query?.from === 'checkout' && !!query?.checkoutState) {
      const checkoutState = JSON.parse(query.checkoutState)
      if (checkoutState.giftCardPrice) {
        const price = state.priceData.find(
          ({ price }) => price === checkoutState.giftCardPrice.price
        ) || { custom: true, price: checkoutState.giftCardPrice.price }
        checkoutState.giftCardPrice = price
      }
      resetGiftCardState(checkoutState, dispatch)
    }
  }, [router, state.priceData])

  useEffect(() => {
    const fetchPackages = async marketId => {
      try {
        const products = await fetchMarketPackages(marketId)
        const groupedPackages = groupBy(products, 'productGroup.name')
        dispatch({ type: 'SET_GROUPS', groups: groupedPackages })
        dispatch({
          type: 'SET_SELECTED_GROUP',
          group: Object.keys(groupedPackages)[0]
        })
      } catch (e) {
        //TODO: handle error
        console.error(e)
      }
    }
    if (selectedMarket) { fetchPackages(selectedMarket.id) }
  }, [selectedMarket, dispatch])

  useEffect(() => {
    const _fetchGiftCard = async () => {
      const giftCard = await fetchGiftCard()
      dispatch({ type: 'SET_GIFT_CARD', giftCard: giftCard })
    }
    try {
      _fetchGiftCard()
    } catch (e) {
      //TODO: handle error
      console.error(e)
    }
  }, [])

  useEffect(() => {
    if (router?.asPath?.split('#')?.length > 1 && router?.asPath?.split('#')[1] === 'package') {
      dispatch({ type: 'SET_GIFT_OPTION', option: 'package' })
    } 
  }, [router])

  return (
    <GiftCardContext.Provider value={{ state, dispatch }}>
      <Head>
        <title>Beauty Gift Cards | GLAMSQUAD</title>
        <meta name="description" content="Give the gift of glam. GLAMSQUAD gift cards are redeemable for in-home hair, makeup, and nail services — the perfect present for any occasion." />
        <link rel="canonical" href="https://glamsquad.com/gift-card" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Beauty Gift Cards | GLAMSQUAD" />
        <meta property="og:description" content="Give the gift of glam. GLAMSQUAD gift cards are redeemable for in-home hair, makeup, and nail services." />
        <meta property="og:url" content="https://glamsquad.com/gift-card" />
      </Head>
      <GiftCardWrapper>
        <Hero />
        <ChooseGift />
        {state.giftOption === 'gift-card'
          ? <ChooseAmount />
          : (
            <>
              <Location {...{ markets, setSelectedMarket, selectedMarket }} />
              <ChoosePackage />
            </>
          )
        }
        <RecipientInfo
          ref={section4}
          selectedMarket={selectedMarket}
        />
      </GiftCardWrapper>
    </GiftCardContext.Provider>
  )
}

export default GiftCards
